<template>
  <div>
    <v-btn label="sort"
      text
      @mousedown.stop="startDrag($event)"
      @click.stop="nothing()"
    >
      {{ index }}.
      <v-icon style="padding-left: 10px;">fa-grip-lines</v-icon>
      <!-- {{ value.item.sortOrder }} -->
    </v-btn>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ListSortField',

  data () {
    return {
    }
  },

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: null
    }
  },

  computed: {
    ...mapFields(['draggedX', 'draggedY', 'draggingId', 'dragElOrigY', 'dragElOrigX', 'dragOrigWidth',
    'dragOrigHeight', 'dragPlaceholderId','dragStartX', 'dragStartY', 'draggingIndex'])
  },

  methods: {
    startDrag (e) {
      let dragEl = document.getElementById('list-id-' + this.value.item._id)
      this.dragElOrigX = dragEl.offsetLeft
      this.dragElOrigY = dragEl.offsetTop
      this.dragOrigHeight = dragEl.offsetHeight
      this.dragOrigWidth = dragEl.offsetWidth
      this.draggingId = this.value.item._id
      this.draggingIndex = this.value.index

      this.dragStartX = e.clientX
      this.dragStartY = e.clientY
      this.dragPlaceholderId = this.value.item._id

      this.draggedX = e.clientX - this.dragStartX
      this.draggedY = e.clientY - this.dragStartY

    },

    nothing () {

    }
  }
}
</script>
